// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'history';

export const Component = () => (
  <path d='M12.774 12.574s0 .38.283.617l2.568 2.154a.503.503 0 1 0 .647-.77l-2.491-2.09v-4.7a.503.503 0 0 0-1.007 0v4.789ZM6.32 14.362a7.417 7.417 0 0 1-.121-3.456 7.353 7.353 0 0 1 2.012-3.74 7.375 7.375 0 1 1 10.43 10.431 7.342 7.342 0 0 1-4.344 2.109c-.275.111-.444.28-.51.509-.097.343.34.57.559.558 1.985-.112 3.49-.949 5.007-2.465a8.382 8.382 0 1 0-14.174-7.421 8.44 8.44 0 0 0 .052 3.255L3.858 12.77a.503.503 0 0 0-.71.711l2.37 2.37A.501.501 0 0 0 5.89 16a.5.5 0 0 0 .376-.15l2.35-2.391a.502.502 0 1 0-.717-.705L6.32 14.36v.002Z' />
);

export const viewBox = '0 0 25 25';
